import { lazyLoad } from "../modules/Utils";

document.addEventListener("DOMContentLoaded", function () {
    var loading = false;

    var ajaxPagination = function () {
        var $pagination = document.querySelector("[data-ajax-next-page]"),
            $row = document.querySelector(".catalog-category-block .row");

        if ($pagination && $row && !loading) {
            // console.log("loading more");
            loading = true;
            var parser = new DOMParser();
            $pagination.classList.add("is-loading");
            fetch($pagination.dataset.ajaxNextPage)
                .then((response) => response.text())
                .then((data) => {
                    let $ajaxData = parser.parseFromString(data, "text/html");
                    let $ajaxItems = $ajaxData.querySelectorAll(
                        ".catalog-category-block .row .catalog-category-block-item"
                    );
                    let $ajaxPagination =
                        $ajaxData.querySelector(".pagination");

                    $ajaxItems.forEach(($ajaxItem) => $row.append($ajaxItem));
                    $pagination.replaceWith($ajaxPagination);

                    lazyLoad();
                    loading = false;
                })
                .catch((error) => console.error("Error:", error));
        }
    };

    document.addEventListener("click", (e) => {
        if (e.target.closest(".pagination__ajax")) {
            ajaxPagination();
        }
    });

    // document.addEventListener("scroll", (event) => {
    //     var $pagination = document.querySelector("[data-ajax-next-page]");
    //     if (
    //         $pagination &&
    //         $pagination.getBoundingClientRect().top < window.innerHeight * 2
    //     ) {
    //         ajaxPagination();
    //     }
    // });
});
